import { useRef, useEffect } from 'react';
import cn from 'classnames';
import Either from '@components/Either';
import { ProductImageProps } from './productCard.types';
import styles from './productCard.module.scss';

const ProductImage = (propAttrs: ProductImageProps) => {
  const { shouldShowImage = true, name, image, icon, className } = propAttrs;
  const imageContainerRef = useRef<any>(null);

  useEffect(() => {
    const ref = imageContainerRef.current;
    if (!ref) return null;
    return ref.style.setProperty('--image', `url(${image})`);
  }, [image]);

  if (!image) {
    return (
      <div className={cn('marginTop-small2', styles.imageContainer)} ref={imageContainerRef}>
        <img alt={name} src="/_nextassets_/images/HT-logo-SHP.png" className={styles.skuImage} />
      </div>
    );
  }
  return (
    <>
      <Either condition={shouldShowImage}>
        <div className={cn(className, styles.imageContainer)} ref={imageContainerRef}>
          <img alt={name} src={image} className={styles.skuImage} />
        </div>
        <img alt={name} src={icon} className={styles.icon} ref={imageContainerRef} />
      </Either>
    </>
  );
};

export default ProductImage;
